import * as React from 'react';
import {Svg, Rect, Path} from 'react-native-svg';

const NormalLevelIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Rect width={24} height={24} rx={4} fill="#23CE00" />
      <Path
        d="M10.806 9.811a.75.75 0 00.891.92l3.898-.88a2.068 2.068 0 012.38 2.776l-1.71 4.342a3.096 3.096 0 01-1.903 1.804 10.32 10.32 0 01-4.475.455l-2.117-.252a1.986 1.986 0 01-1.74-1.755l-.325-2.962a5 5 0 01.867-3.403l4.231-6.077a.65.65 0 011.163.533l-1.16 4.5z"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default NormalLevelIcon;
